/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * There are two loading styles available:
 * 1.  Inlined circular spinner icon with optional text
 *    <loaders display-text="Getting the best prices..." small></loaders>
 * 2.  Content block to indicate a block of text (example below is for 2 right-aligned blocks)
 *    <loaders block-array="[{width: '30px', height: '15px'}, {width: '100px', height: '25px'}]" block-align="right"></loaders>
 *
 * @module enervee_utils.loaders
 */
function loadersDirective() {
    return {
        restrict: 'E',
        scope: {
            displayText: '@',
            blockArray: '<',
            blockAlign: '@'
        },
        link: function (scope, elem, attrs) {
            // we're really only checking if this attr exists, not the value
            scope.isSmall = attrs.hasOwnProperty('small');
            scope.isCircle = attrs.hasOwnProperty('circle');
        },
        template: require('./loadersView.html')
    };
}

module.exports = loadersDirective;
